let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9hgjX")).then(() => parcelRequire('f19h5'));